import script from "./AldLanguageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AldLanguageSelector.vue?vue&type=script&setup=true&lang=js"

import "./AldLanguageSelector.vue?vue&type=style&index=0&id=7ee6f04c&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee6f04c"]])

export default __exports__